import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const getFailureContent = (paymentResult) => {
  switch (paymentResult) {
    case 'cancel':
      return {
        title: 'Payment Cancelled',
        message: 'Your payment was cancelled before completion.',
      };
    case 'duplicate':
      return {
        title: 'Payment Already Processed',
        message: 'This payment session was already processed. Start a new payment if you still need to submit the form.',
      };
    default:
      return {
        title: 'Payment Failed',
        message: 'There was an issue processing your payment. You can retry with a new payment session.',
      };
  }
};

const FailurePage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);
  const paymentResult = searchParams.get('paymentResult') || 'failure';
  const { title, message } = getFailureContent(paymentResult);

  const handleRetry = () => {
    const stored = sessionStorage.getItem('dui_payment_data');

    if (!stored) {
      navigate('/form');
      return;
    }

    try {
      const paymentData = JSON.parse(stored);
      const userData = {
        role: paymentData.role || '',
        firstName: paymentData.firstName || '',
        middleName: paymentData.middleName || '',
        lastName: paymentData.lastName || '',
        dateOfBirth: paymentData.dateOfBirth || '',
        email: paymentData.email || '',
        jailId: paymentData.jailId || '',
        policeReportNumber: paymentData.policeReportNumber || '',
        fileNumber: paymentData.fileNumber || '',
      };

      navigate('/payment', { state: { userData } });
    } catch {
      sessionStorage.removeItem('dui_payment_data');
      navigate('/form');
    }
  };

  return (
    <div className="failure-overlay">
      <div className="failure-content">
        <h1>{title}</h1>
        <p>{message}</p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button onClick={handleRetry}>Try Again</button>
          <button onClick={() => navigate('/')}>Return Home</button>
        </div>
      </div>
    </div>
  );
};

export default FailurePage;